import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import {of, from, tap} from 'rxjs';
import { switchMap, map, catchError, withLatestFrom } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import {
  loadBuildKitNames,
  loadBuildKitNamesFailure,
  loadBuildKitNamesSuccess,
  loadCadModelNames,
  loadCadModelNamesFailure,
  loadCadModelNamesSuccess,
  loadCotsTypeNames,
  loadCotsTypeNamesFailure,
  loadCotsTypeNamesSuccess,
  loadMaterialFamilyNames,
  loadMaterialFamilyNamesFailure,
  loadMaterialFamilyNamesSuccess, loadMaterialNames, loadMaterialNamesFailure, loadMaterialNamesSuccess,
  loadMaterialTypeNames,
  loadMaterialTypeNamesFailure,
  loadMaterialTypeNamesSuccess,
  loadOrganizationNames,
  loadOrganizationNamesFailure,
  loadOrganizationNamesSuccess,
  loadProjectNames,
  loadProjectNamesFailure,
  loadProjectNamesSuccess,
  loadShapeTypeNames,
  loadShapeTypeNamesFailure,
  loadShapeTypeNamesSuccess
} from "./dropdown-data.action";
import {AppState} from "../../../shared/state/app.state";
import {GlobalConfigService} from "../../../global-config/data-access/global-config.service";


@Injectable()
export class DropdownDataEffects {
  loadMaterialFamilies$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadMaterialFamilyNames),
      switchMap((action) =>
        this.globalConfigService.getNamesAndIds('materialFamily')
          .pipe(
            map((materialFamilyNames) => loadMaterialFamilyNamesSuccess({materialFamilyNames: materialFamilyNames})),
            catchError((error) => of(loadMaterialFamilyNamesFailure({ error })))
          )
      )
    )
  );

  loadMaterialTypeNames$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadMaterialTypeNames),
      switchMap((action) =>
        this.globalConfigService.getNamesAndIds('materialType')
          .pipe(
            map((materialTypeNames) => loadMaterialTypeNamesSuccess({materialTypeNames: materialTypeNames})),
            catchError((error) => of(loadMaterialTypeNamesFailure({ error })))
          )
      )
    )
  );

  loadMaterialNames$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadMaterialNames),
      switchMap((action) =>
        this.globalConfigService.getNamesAndIds('material')
          .pipe(
            map((materialNames) => loadMaterialNamesSuccess({materialNames: materialNames})),
            catchError((error) => of(loadMaterialNamesFailure({ error })))
          )
      )
    )
  );

  loadOrganizations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadOrganizationNames),
      switchMap((action) =>
        this.globalConfigService.getNamesAndIds('organization')
          .pipe(
            map((organizationNames) => loadOrganizationNamesSuccess({organizationNames: organizationNames})),
            catchError((error) => of(loadOrganizationNamesFailure({ error })))
          )
      )
    )
  );

  loadShapeTypes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadShapeTypeNames),
      switchMap((action) =>
        this.globalConfigService.getNamesAndIds('shapeType')
          .pipe(
            map((shapeTypeNames) => loadShapeTypeNamesSuccess({shapeTypeNames: shapeTypeNames})),
            catchError((error) => of(loadShapeTypeNamesFailure({ error })))
          )
      )
    )
  );

  loadCotsTypes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadCotsTypeNames),
      switchMap((action) =>
        this.globalConfigService.getNamesAndIds('cotsType')
          .pipe(
            map((cotsTypeNames) => loadCotsTypeNamesSuccess({cotsTypeNames: cotsTypeNames})),
            catchError((error) => of(loadCotsTypeNamesFailure({ error })))
          )
      )
    )
  );

  loadProjects$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadProjectNames),
      switchMap((action) =>
        this.globalConfigService.getNamesAndIds('project')
          .pipe(
            map((projectNames) => loadProjectNamesSuccess({projectNames: projectNames})),
            catchError((error) => of(loadProjectNamesFailure({ error })))
          )
      )
    )
  );

  loadBuildKits$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadBuildKitNames),
      switchMap((action) =>
        this.globalConfigService.getNamesAndIds('buildKit')
          .pipe(
            map((buildKitNames) => loadBuildKitNamesSuccess({buildKitNames: buildKitNames})),
            catchError((error) => of(loadBuildKitNamesFailure({ error })))
          )
      )
    )
  );

  loadCadModels$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadCadModelNames),
      switchMap((action) =>
        this.globalConfigService.getNamesAndIds('cadModel')
          .pipe(
            map((cadModelNames) => loadCadModelNamesSuccess({cadModelNames: cadModelNames})),
            catchError((error) => of(loadCadModelNamesFailure({ error })))
          )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private globalConfigService: GlobalConfigService
  ) {}
}
